/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDevicesRequest
 */
export interface GetDevicesRequest {
    /**
     * 
     */
    hostnames: Array<string>;
}

/**
 * Check if a given object implements the GetDevicesRequest interface.
 */
export function instanceOfGetDevicesRequest(value: object): value is GetDevicesRequest {
    if (!('hostnames' in value) || value['hostnames'] === undefined) return false;
    return true;
}

export function GetDevicesRequestFromJSON(json: any): GetDevicesRequest {
    return GetDevicesRequestFromJSONTyped(json, false);
}

export function GetDevicesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDevicesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hostnames': json['hostnames'],
    };
}

export function GetDevicesRequestToJSON(json: any): GetDevicesRequest {
    return GetDevicesRequestToJSONTyped(json, false);
}

export function GetDevicesRequestToJSONTyped(value?: GetDevicesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostnames': value['hostnames'],
    };
}

